import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=6df61e17&scoped=true&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&id=6df61e17&scoped=true&lang=css&"
import style1 from "./PostForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df61e17",
  null
  
)

export default component.exports